import React from 'react'
import DocumentTitle from 'react-document-title'

import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import DateRangePicker from 'components/date-range-picker'
import SingleDatePicker from 'components/single-date-picker'

class DatesPage extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      range: false,
      dates: [],
    }

    this.handleChangeMode = this.handleChangeMode.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.format = this.format.bind(this)
  }

  handleChangeMode() {
    this.setState({
      range: !this.state.range,
    })
  }

  handleChange(dates) {
    this.setState({ dates })
  }

  format(date) {
    return date.format('YYYY-MM-DD')
  }

  render() {
    return (
      <DocumentTitle title="Ecommerce Portal - Time Out - Dates">
        <RelayoutWrapper from="md">
          <Relayout align="center">
            <RelayoutItem xl="10">
              <div>
                <h1>When is your event?</h1>
                <p>
                  Select <span>all the dates</span> of your event. Running a multi-day event?
                  <button onClick={this.handleChangeMode}>Select a date range</button>.
                </p>
                {this.state.range ? (
                  <DateRangePicker
                    {...this.state}
                    format={this.format}
                    onChange={this.handleChange}
                    onClose={this.handleChangeMode}
                  />
                ) : (
                  <SingleDatePicker
                    {...this.state}
                    format={this.format}
                    onChange={this.handleChange}
                  />
                )}
              </div>
            </RelayoutItem>
          </Relayout>
        </RelayoutWrapper>
      </DocumentTitle>
    )
  }

}

export default DatesPage



/** WEBPACK FOOTER **
 ** ./src/containers/dates-page/dates-page.js
 **/